module.exports = __webpack_public_path__ + "img/CH01-044-045.7f14dafa.jpg";